import React, { useEffect, useState } from "react";
import {
  FolderOpenOutlined,
  EditOutlined,
  EyeOutlined,
  DownloadOutlined,
  DeleteOutlined,
  FileImageOutlined,
  FilePdfOutlined,
  MailOutlined,
} from "@ant-design/icons";
import Notiflix from "notiflix";
import {
  Table,
  Typography,
  Input,
  Form,
  Col,
  Divider,
  Row,
  Descriptions,
  Button,
  Tooltip,
  Modal,
  Spin,
  Space,
  List,
  Avatar,
} from "antd";

//PROJECT IMPORTS
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import CustomPagination from "../../../../../components/CustomPagination";
import { useNavigate } from "react-router-dom";
import appConfig from "../../../../../config/appConfig";
import axios from "axios";

const { Text, Title } = Typography;

const Certificate = (props) => {
  const navigate = useNavigate();
  const {
    state,
    userData,
    currentPage,
    setCurrentPage,
    tableCount,
    setTableCount,
    totalItems,
    setTotalItems,
    onRefresh,
    certificateList,
  } = props;
  const { session } = userData;
  const [isLoading, setIsLoading] = useState(false);
  const [certificate, setCertificate] = useState(null);
  const [viewableCertificate, setViewableCertificate] = useState(null);
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);

  function handleJournalEntries() {
    navigate("/fixed-journal-entries", { state: state });
  }

  function getCertificate() {
    setIsLoading(true);

    let body = {
      session,
    };

    const url = `${apiConfig.treasuryCertificates}/contract/FIXED_DEPOSIT/${state.id}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      setIsLoading(false);
      if (err) {
        // BOM.AlertMsg(cnt.DANGER, err);
      } else {
        setCertificate(res);
        setIsLoading(false);
      }
    });
  }
  function generateCertificate() {
    const url = `${apiConfig.certificates}/generate`;
    const body = {
      contractType: "FIXED_DEPOSIT",
      contractId: state.id,
      method: "POST",
      session,
    };
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      setIsLoading(false);
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        // setIsLoading(false);
      } else {
        setCertificate(res);
      }
    });
  }
  function regenerateCertificate() {
    const url = `${apiConfig.certificates}/generate`;
    const body = {
      contractType: "FIXED_DEPOSIT",
      contractId: state.id,
      method: "POST",
      session,
    };
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      setIsLoading(false);
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        // setIsLoading(false);
      } else {
        setCertificate(res);
      }
    });
  }

  React.useEffect(() => {
    getCertificate();
  }, []);

  console.log(certificate);

  const handleDownload = async (item) => {
    try {
      const url = `${apiConfig.certificates}/${item.certificateId}/download`;

      const { headers } = appConfig.apiSettings;
      headers.Authorization = session;

      const tfaToken = localStorage.getItem("tfaToken");
      if (tfaToken && tfaToken !== "null" && tfaToken !== "undefined") {
        headers["Fineract-Platform-TFA-Token"] = tfaToken;
      } else {
        delete headers["Fineract-Platform-TFA-Token"];
      }

      const response = await axios({
        method: "GET",
        url: url,
        headers: headers,
        responseType: "blob",
      });

      const blob = new Blob([response.data], { type: "application/pdf" });
      const resUrl = window.URL.createObjectURL(blob);

      // Store blob URL for preview
      setPdfBlobUrl(resUrl);
      setViewableCertificate(`certificate-${item.certificateNumber}.pdf`);

      // Download the file
      const a = document.createElement("a");
      a.href = resUrl;
      a.download = `certificate-${item.certificateNumber}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      // Note: Don't revoke URL immediately if we want to use it for preview
      // It will be revoked when modal closes or component unmounts
    } catch (error) {
      console.error("Download error:", error);
      if (error.response) {
        BOM.AlertMsg(
          cnt.DANGER,
          error.response.data?.defaultUserMessage || "Failed to download document",
        );
      } else {
        BOM.AlertMsg(cnt.DANGER, "Failed to download document");
      }
    }
  };

  return (
    <>
      <Spin spinning={isLoading} size="large">
        <Button
          type="primary"
          shape="round"
          className="of-primaryBtnColor"
          onClick={certificate ? regenerateCertificate : generateCertificate}
        >
          <FolderOpenOutlined />
          &nbsp;{certificate ? labelConfig.regenerateCertificate : labelConfig.generateCertificate}
        </Button>
        <Divider orientation="left" />
        <List
          itemLayout="horizontal"
          dataSource={certificate ? [certificate] : []}
          renderItem={(item, index) => (
            <List.Item
              key={index}
              actions={[
                <Button
                  type="primary"
                  onClick={() => handleDownload(item)}
                  shape="round"
                  size="small"
                  icon={<DownloadOutlined />}
                >
                  Download
                </Button>,

                <ViewCertificateModal
                  certificate={item}
                  pdfBlobUrl={pdfBlobUrl}
                  setPdfBlobUrl={setPdfBlobUrl}
                  session={session}
                />,
                <Button type="primary" danger shape="round" size="small" icon={<MailOutlined />}>
                  Send as email
                </Button>,
              ]}
            >
              <List.Item.Meta
                avatar={
                  <Avatar
                    style={{ fontSize: 25 }}
                    icon={
                      true ? (
                        <FileImageOutlined style={{ fontSize: 25, color: "green" }} />
                      ) : (
                        <FilePdfOutlined style={{ fontSize: 25, color: "red" }} />
                      )
                    }
                  />
                }
                title={item?.certificateNumber}
                description={item?.description}
              />
            </List.Item>
          )}
        />
      </Spin>
    </>
  );
};

export default Certificate;

const ViewCertificateModal = (props) => {
  const { certificate, pdfBlobUrl, setPdfBlobUrl, session } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);

  const fetchCertificateForPreview = async () => {
    if (pdfBlobUrl) {
      // Use existing blob URL if available
      setPreviewUrl(pdfBlobUrl);
      setIsModalOpen(true);
      return;
    }

    // Fetch the certificate blob for preview
    try {
      setIsLoading(true);
      const url = `${apiConfig.certificates}/${certificate.certificateId}/download`;

      const { headers } = appConfig.apiSettings;
      headers.Authorization = session;

      const tfaToken = localStorage.getItem("tfaToken");
      if (tfaToken && tfaToken !== "null" && tfaToken !== "undefined") {
        headers["Fineract-Platform-TFA-Token"] = tfaToken;
      } else {
        delete headers["Fineract-Platform-TFA-Token"];
      }

      const response = await axios({
        method: "GET",
        url: url,
        headers: headers,
        responseType: "blob",
      });

      const blob = new Blob([response.data], { type: "application/pdf" });
      const blobUrl = window.URL.createObjectURL(blob);
      setPreviewUrl(blobUrl);
      setPdfBlobUrl(blobUrl); // Store for potential reuse
      setIsModalOpen(true);
      setIsLoading(false);
    } catch (error) {
      console.error("Preview error:", error);
      setIsLoading(false);
      if (error.response) {
        BOM.AlertMsg(
          cnt.DANGER,
          error.response.data?.defaultUserMessage || "Failed to load certificate",
        );
      } else {
        BOM.AlertMsg(cnt.DANGER, "Failed to load certificate");
      }
    }
  };

  const showModal = () => {
    fetchCertificateForPreview();
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    // Clean up blob URL when modal closes (optional - can keep for reuse)
    // if (previewUrl && previewUrl !== pdfBlobUrl) {
    //   window.URL.revokeObjectURL(previewUrl);
    // }
  };

  // Cleanup blob URL on unmount
  React.useEffect(() => {
    return () => {
      if (previewUrl && previewUrl !== pdfBlobUrl) {
        window.URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl, pdfBlobUrl]);

  return (
    <>
      <Button
        onClick={showModal}
        type="primary"
        danger
        shape="round"
        size="small"
        icon={<EyeOutlined />}
      >
        View
      </Button>
      {/* <Button
          type="primary"
          icon={<FolderOpenOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="of-primaryBtnColor"
        /> */}

      <Modal
        title="View Certificate"
        centered
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={600}
        footer={[
          <Button key="close" onClick={handleCancel}>
            Close
          </Button>,
        ]}
        style={{
          top: 20,
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          {previewUrl && (
            <iframe
              src={`${previewUrl}#toolbar=0`}
              style={{
                width: "100%",
                height: "70vh",
                border: "none",
              }}
              title="Certificate Preview"
            />
          )}
        </Spin>
      </Modal>
    </>
  );
};
